var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEt1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / ET1",
    clipPath: "url(#clip0_1718_2030)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9281 20.125L18.6958 14.3573L17.2156 12.877L12.9026 17.1901L10.7588 15.0463L9.30415 16.501L12.9281 20.125ZM7.87498 24.2083C7.31352 24.2083 6.83288 24.0084 6.43305 23.6086C6.03323 23.2087 5.83331 22.7281 5.83331 22.1666V5.83329C5.83331 5.27183 6.03323 4.79119 6.43305 4.39137C6.83288 3.99154 7.31352 3.79163 7.87498 3.79163H16.0416L22.1666 9.91663V22.1666C22.1666 22.7281 21.9667 23.2087 21.5669 23.6086C21.1671 24.0084 20.6864 24.2083 20.125 24.2083H7.87498ZM15.0208 10.9375V5.83329H7.87498V22.1666H20.125V10.9375H15.0208Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1718_2030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEt1Icon);
export default __webpack_public_path__ + "static/media/ET1-icon.2fe74701305e425260ba2a8ae801eb57.svg";
export { ForwardRef as ReactComponent };